// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__hNRCL","spinAnimation":"style_spinAnimation__+4zMP"};